export const projectStatusCategories = [
  "In Progress",
  "Completed",
  "Proposed",
];

export const projectConfig = {
  byId: {
    "colorado-1": {
      name: "UCOL Snow Streamgages Network",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "The objective of this project is to establish and operate a core network of USGS continuous snow monitoring stations positioned within these key elevation ranges of the NGWOS UCOL Basin to provide high-quality, representative, and publicly-available data on snowpack, soil moisture, and meteorological conditions.",
      contacts: [
        {
          name: "Graham Sextone",
          title: "Project Lead",
          contactInfo: {
            email: "sextone@usgs.gov",
            phone: "303-236-6878",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/ucrb_projects/FY2022_UCOL_NGWOS_SnowStreamgages.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/ucrb_projects/FY2022_UCOL_NGWOS_SnowStreamgages.xlsx",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10337d34e7fc6a05060f5",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-upper-colorado-river",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-upper-colorado-river",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10337d34e7fc6a05060f5",
        },
      ],
    },
    "colorado-2": {
      name: "UCOL Regional GW Level and Spring Monitoring Network",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "A critical component of water-resource management in the western United States is the accurate estimation of the current and future water budgets; however, gaps in hydrologic data related to groundwater present challenges to modeling efforts. We aim to establish a groundwater-level and spring-discharge monitoring network for the Upper Colorado (UCOL) River Basin, with the specific purpose of providing essential data for ongoing and future integrated hydrologic models of snowmelt, streamflow, and groundwater-flow processes. The work will be completed by an interdisciplinary team of modelers, data specialists, and field scientists from across different Water Science Centers (WSC) and the Water Mission Area (WMA).",
      contacts: [
        {
          name: "Connor Newman",
          title: "Project Lead",
          contactInfo: {
            email: "cpnewman@usgs.gov",
            phone: "303-236-6905",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/ucrb_projects/NGWOS+FY22+Proposal+UCOL+GW+Monitoring.docx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/ucrb_projects/NGWOS+FY22+Proposal+UCOL+GW+Monitoring.docx",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10337d34e7fc6a05060f5",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-upper-colorado-river",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-upper-colorado-river",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10337d34e7fc6a05060f5",
        },
      ],
    },
    "colorado-3": {
      name: "UCOL Novel Detection of Bedload Movement during Flushing Flows",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "This project will expand on a 2019 study that tested the use of a hydrophone (an underwater microphone) to detect bedload movement using novel sensors in the upper Colorado River and determine the point at which gravel bed sediment begins to mobilize and impact aquatic habitat. The first phase will involve installing a NGWOS-owned, high-end underwater camera alongside a gratis turbidity probe and lower-cost underwater camera to evaluate the use of underwater cameras for viewing bedload movement. Hydrophones will also be installed near the camera to audibly confirm absence or presence of bedload movement. Future phase(s) will be scoped based on the outcomes of the first phase and may include: in-depth acoustic data analysis to auditorily identify timing of incipient motion and compare with camera observations; improvement of hydrophone signal processing algorithms; and contracting with a vendor specializing in machine learning to test algorithms to detect the size and quantity of bedload movement based on video collected from the underwater camera. ",
      contacts: [
        {
          name: "Mike Kohn",
          title: "Project Lead",
          contactInfo: {
            email: "mkohn@usgs.gov",
            phone: "303-236-6924",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/ucrb_projects/NGWOS_FY21_FY22_UCOL_Incipient+Motion_Budget+Worksheet_ssp.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/ucrb_projects/NGWOS_FY21_FY22_UCOL_Incipient+Motion_Budget+Worksheet_ssp.xlsx",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10337d34e7fc6a05060f5",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-upper-colorado-river",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-upper-colorado-river",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10337d34e7fc6a05060f5",
        },
      ],
    },
    "colorado-4": {
      name: "Real-Time Under-Ice and Open-Water Measurements of Discharge",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "Streamflow was identified as a priority by the stakeholders in the Upper Colorado (UCOL) Next Generation Water Observing System (NGWOS) Basin in April 2020. Standard methods for computing winter- and open-water streamflow are reported by Turnipseed and Sauer (2010), Rantz et al. (1982), Buchanan and Somers (1969), and Nolan and Jacobson (2000). For winter streamflow, the quality of the measurement is commonly assigned a rating of “Poor,” in part because of (1) an inability to collect a sufficient number of velocity measurements, (2) variations in water depth, and (3) occurrence of a non-standard velocity distribution. For open-water streamflow, the utility of NonContact measurements and novel discharge algorithms can address a data gap in ungaged basins where it is difficult to establish a stage-discharge rating because of access or hydraulic challenges. Developing a method for measuring real-time river discharge for under-ice and open-water allows decision makers to monitor temporal variations in streamflow throughout the year and provide a more comprehensive accounting of water.",
      contacts: [
        {
          name: "John Fulton",
          title: "Project Lead",
          contactInfo: {
            email: "jwfulton@usgs.gov",
            phone: "(775) 525-4668",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/ucrb_projects/NGWOS_FY22_UCOL_UnderIce_01Aug2021.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/ucrb_projects/NGWOS_FY22_UCOL_UnderIce_01Aug2021.xlsx",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10337d34e7fc6a05060f5",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-upper-colorado-river",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-upper-colorado-river",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10337d34e7fc6a05060f5",
        },
      ],
    },
    "colorado-5": {
      name: "Analysis of NADP Precipitation from stable isotopes for UCOL and DRB",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "The aim is to analyze samples from National Atmospheric Deposition Project (NADP) sites for stable hydrogen and oxygen isotopic analysis. These data can serve as inputs for isotope hydrology studies. These data can be used to evaluate groundwater models, investigate groundwater-surface water interaction, etc.",
      contacts: [
        {
          name: "Tyler Coplen",
          title: "Project Lead",
          contactInfo: {
            email: "tbcoplen@usgs.gov",
            phone: "703-648-5862",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/ucrb_projects/NADP_Isotopes_Email.pdf",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/ucrb_projects/NADP_Isotopes_Email.pdf",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10337d34e7fc6a05060f5",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-upper-colorado-river",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-upper-colorado-river",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10337d34e7fc6a05060f5",
        },
      ],
    },
    "colorado-6": {
      name: "Collection of high-accuracy observations of solar radiation",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "The data collection effort focuses on enhancing three USGS snowpack monitoring stations, spanning an elevational and spatial gradient, with high accuracy (<1.8% uncertainty) pyranometer pairs to measure incoming and outgoing broadband, visible, and near infrared solar radiation to quantify snow albedo, and the spectrally varying controls on snow albedo. This set of measurements can also be used to monitor the enhanced absorption of solar radiation by dust, known as dust radiative forcing. These observations will provide high-quality datasets that can support future studies focused on modeling and remote sensing retrievals of snow albedo, dust radiative forcing, and  influences on albedo and snowmelt timing across a broader range of sites in the Colorado River headwaters.",
      contacts: [
        {
          name: "Natalie Day",
          title: "Project Lead",
          contactInfo: {
            email: "nkday@usgs.gov",
            phone: "970-628-7144",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/ucrb_projects/NGWOS_FY22-UCOL_MONITORINGDUST_08022021.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/ucrb_projects/NGWOS_FY22-UCOL_MONITORINGDUST_08022021.xlsx",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10337d34e7fc6a05060f5",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-upper-colorado-river",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-upper-colorado-river",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10337d34e7fc6a05060f5",
        },
      ],
    },
    "colorado-7": {
      name: "Water Isotope Network Basin-Wide Monitoring",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "Measure ratios of stable isotopes of water (δ18O and δ2H) and concentrations of tritium (3H) in streamflow and precipitation in the Upper Colorado River Basin. Such data trace important hydrologic processes and can be used to improve model predictions of water availability.",
      contacts: [
        {
          name: "Carleton Bern",
          title: "Project Lead",
          contactInfo: {
            email: "cbern@usgs.gov",
            phone: "303-236-1024",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/ucrb_projects/NGWOS_FY22-Water_Isotope_Network_Project-Plan-Worksheet+(1).xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/ucrb_projects/NGWOS_FY22-Water_Isotope_Network_Project-Plan-Worksheet+(1).xlsx",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10337d34e7fc6a05060f5",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-upper-colorado-river",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-upper-colorado-river",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10337d34e7fc6a05060f5",
        },
      ],
    },
    "colorado-8": {
      name: "Supergages on CO River in Utah",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "Real-time water quality and weather monitoring equipment installed at the San Juan River near Bluff, UT (09379500), Green River near Green River, UT (09315000), Green River near Jensen, UT (09261000), and Colorado River near Cisco, UT (09180500).  Note some weather sensors are on back order.  In addition, dataloggers upgraded at the gages listed above and Dolores River near Cisco, UT (09180000), and San Rafael River at Mouth near Green River, UT (09328910) to handle additional sensor inputs and to add redundant data telemetry. Finally, non submersible pressure transducers (bubblers) that provide river stage data upgraded at Green River at Green River, UT (09315000) and the Dolores River near Cisco, UT (09180000) as the existing bubblers are near the end of useful life. ",
      contacts: [
        {
          name: "Ryan Rowland",
          title: "Project Lead",
          contactInfo: {
            email: "rrowland@usgs.gov",
            phone: "801-908-5036",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/ucrb_projects/NGWOS_FY22_UCOL_SUPERGAGESUTWSC_08202021.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/ucrb_projects/NGWOS_FY22_UCOL_SUPERGAGESUTWSC_08202021.xlsx",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10337d34e7fc6a05060f5",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-upper-colorado-river",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-upper-colorado-river",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10337d34e7fc6a05060f5",
        },
      ],
    },
    "colorado-9": {
      name: "Software Defined Radar",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "Software-defined Radar (SDRadar) technology can provide an extensible, open-source, low-cost ground-penetrating radar (GPR) for alpine surveys. GPRs surveys measure snow depth and snow water equivalent at greater areal and vertical extent and resolution than that offered through remote sensing or field observations alone. This initiative integrates an SDRadar on a small, unmanned aircraft system (sUAS) system capable of conducting snow surveys from low altitudes and builds on collaborations with the Colorado Department of Transportation (CDOT), USC Viterbi School of Engineering, and USGS National UAS Project Office (NUPO). This air-coupled GPR platform has applications for avalanche risk assessments and water resources planning in the UCOL basin. Specifically, the proposed SDRadar system has the potential to drastically improve snow survey safety by measuring snow depth, snow water equivalent (SWE), and snow liquid water content (LWC) remotely in complex alpine terrain that would otherwise pose safety risks and would be cost prohibitive.",
      contacts: [
        {
          name: "John Fulton",
          title: "Project Lead",
          contactInfo: {
            email: "jwfulton@usgs.gov",
            phone: "(775) 525-4668",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/ucrb_projects/NGWOS_FY22_UCOL_SnowGPR_01Aug2021.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/ucrb_projects/NGWOS_FY22_UCOL_SnowGPR_01Aug2021.xlsx",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10337d34e7fc6a05060f5",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-upper-colorado-river",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-upper-colorado-river",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10337d34e7fc6a05060f5",
        },
      ],
    },
    "colorado-10": {
      name: "Remote Sensing of River Bathymetry",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "Software-defined Radar (SDRadar) technology can provide an extensible, open-source, low-cost ground-penetrating radar (GPR) for alpine surveys. GPRs surveys measure snow depth and snow water equivalent at greater areal and vertical extent and resolution than that offered through remote sensing or field observations alone. This initiative integrates an SDRadar on a small, unmanned aircraft system (sUAS) system capable of conducting snow surveys from low altitudes and builds on collaborations with the Colorado Department of Transportation (CDOT), USC Viterbi School of Engineering, and USGS National UAS Project Office (NUPO). This air-coupled GPR platform has applications for avalanche risk assessments and water resources planning in the UCOL basin. Specifically, the proposed SDRadar system has the potential to drastically improve snow survey safety by measuring snow depth, snow water equivalent (SWE), and snow liquid water content (LWC) remotely in complex alpine terrain that would otherwise pose safety risks and would be cost prohibitive.",
      contacts: [
        {
          name: "Carl Legleiter",
          title: "Project Lead",
          contactInfo: {
            email: "cjl@usgs.gov",
            phone: "303-271-3651",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/ucrb_projects/NGWOS_FY21_UCOL_RemoteSensing_031221.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/ucrb_projects/NGWOS_FY21_UCOL_RemoteSensing_031221.xlsx",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10337d34e7fc6a05060f5",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-upper-colorado-river",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-upper-colorado-river",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10337d34e7fc6a05060f5",
        },
      ],
    },
    "colorado-11": {
      name: "Non-Contact Velocity/Stage Radars and Cameras for Real-Time Discharge",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "Streamflow was identified as a priority by the stakeholders in the Upper Colorado (UCOL) Next Generation Water Observing System (NGWOS) Basin in April 2020. Standard methods for computing winter- and open-water streamflow are reported by Turnipseed and Sauer (2010), Rantz et al. (1982), Buchanan and Somers (1969), and Nolan and Jacobson (2000). For winter streamflow, the quality of the measurement is commonly assigned a rating of “Poor,” in part because of (1) an inability to collect a sufficient number of velocity measurements, (2) variations in water depth, and (3) occurrence of a non-standard velocity distribution. For open-water streamflow, the utility of NonContact measurements and novel discharge algorithms can address a data gap in ungaged basins where it is difficult to establish a stage-discharge rating because of access or hydraulic challenges. Developing a method for measuring real-time river discharge for under-ice and open-water allows decision makers to monitor temporal variations in streamflow throughout the year and provide a more comprehensive accounting of water.",
      contacts: [
        {
          name: "John Fulton",
          title: "Project Lead",
          contactInfo: {
            email: "jwfulton@usgs.gov",
            phone: "(775) 525-4668",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/ucrb_projects/NGWOS_FY21_UCOL_NonContactDischarge_030521.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/ucrb_projects/NGWOS_FY21_UCOL_NonContactDischarge_030521.xlsx",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10337d34e7fc6a05060f5",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-upper-colorado-river",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-upper-colorado-river",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10337d34e7fc6a05060f5",
        },
      ],
    },
    "colorado-12": {
      name: "Upgrades to Lee's Ferry",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "The Arizona Water Science Center will upgrade data collection equipment and begin monitoring additional water-quality parameters at the Colorado River at Lees Ferry streamflow station (USGS station 09380000). Water-quality parameters to be collected include pH, dissolved oxygen (DO), and Fluorescent Dissolved Organic Matter (fDOM) which will supplement the water temperature and specific conductance parameters that are currently recorded.",
      contacts: [
        {
          name: "Jay Cederberg",
          title: "Project Lead",
          contactInfo: {
            email: "cederber@usgs.gov",
            phone: "928-890-9988",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/ucrb_projects/NGWOS_FY21_UCOL_NonContactDischarge_030521.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/ucrb_projects/NGWOS_FY21_UCOL_NonContactDischarge_030521.xlsx",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10337d34e7fc6a05060f5",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-upper-colorado-river",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-upper-colorado-river",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10337d34e7fc6a05060f5",
        },
      ],
    },
    "colorado-13": {
      name: "Airborn PIV",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "This project will help Water Science Center (WSC) technicians to accurately measure surface flow velocities in river channels by establishing an integrated workflow for Particle Image Velocimetry (PIV) analysis and providing easy-to-use software.  These tools will be developed and tested using remotely sensed data acquired from helicopters and fixed-wing aircraft.  A flexible, user-friendly software package designed for WSC staff, along with training materials, will be developed.  ",
      contacts: [
        {
          name: "Carl Legleiter",
          title: "Project Lead",
          contactInfo: {
            email: "cjl@usgs.gov",
            phone: "303-271-3651",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "Need to locate",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "Need to locate",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10337d34e7fc6a05060f5",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-upper-colorado-river",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-upper-colorado-river",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10337d34e7fc6a05060f5",
        },
      ],
    },
    "illinois-1": {
      name: "Nutrients - Supergages",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "The Illinois River Basin (ILRB) has been identified as a major source of nutrients that contribute to the formation of hypoxia issues in the Gulf of Mexico.  The objective of ILRB NGWOS is to expand nutrient monitoring locations to better understand the distribution of nutrient loads, transport, retention and cycling processes in the basin and sub-basins.",
      contacts: [
        {
          name: "James Duncker",
          title: "Basin Coordinator",
          contactInfo: {
            email: "jduncker@usgs.gov",
            phone: "217-493-7512",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://s3.console.aws.amazon.com/s3/object/ngwos-app-data?region=us-west-2&prefix=layer_data/irb_projects/FY22_NTG_Supergages.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "x",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10379d34e7fc6a05060fb",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10379d34e7fc6a05060fb",
        },
      ],
    },
    "illinois-2": {
      name: "Nutrients - GW-SW Interaction",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "The Illinois River Basin (ILRB) has been identified as a major source of nutrients that contribute to the formation of hypoxia issues in the Gulf of Mexico.  The objective of ILRB NGWOS is to expand nutrient monitoring locations to better understand the distribution of nutrient loads, transport, retention and cycling processes in the basin and sub-basins.",
      contacts: [
        {
          name: "James Duncker",
          title: "Basin Coordinator",
          contactInfo: {
            email: "jduncker@usgs.gov",
            phone: "217-493-7512",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://s3.console.aws.amazon.com/s3/object/ngwos-app-data?region=us-west-2&prefix=layer_data/irb_projects/FY22_NTG_Nutrients_GW_SW+interaction.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "x",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10379d34e7fc6a05060fb",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10379d34e7fc6a05060fb",
        },
      ],
    },
    "illinois-3": {
      name: "Nutrients - Legacy Nutrients",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "The Illinois River Basin (ILRB) has been identified as a major source of nutrients that contribute to the formation of hypoxia issues in the Gulf of Mexico.  The objective of ILRB NGWOS is to expand nutrient monitoring locations to better understand the distribution of nutrient loads, transport, retention and cycling processes in the basin and sub-basins.",
      contacts: [
        {
          name: "James Duncker",
          title: "Basin Coordinator",
          contactInfo: {
            email: "jduncker@usgs.gov",
            phone: "217-493-7512",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://s3.console.aws.amazon.com/s3/object/ngwos-app-data?region=us-west-2&prefix=layer_data/irb_projects/FY22_NTG_Legacy+nutrients.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "x",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10379d34e7fc6a05060fb",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10379d34e7fc6a05060fb",
        },
      ],
    },
    "illinois-4": {
      name: "Harmful Algal Blooms",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "The objective of the NGWOS ILRB HABs monitoring is to evaluate new multi-spectral imaging sensors, fluorometers, and passive sampling equipment (SPATT) for identifying the occurrence of HABs (e.g. excessive chlorophyll, high algae abundances, presence of nuisance and potential toxin-producing taxa and toxins) in the Illinois River Basin. Multi-spectral imaging tools will also be evaluated for monitoring of other water quality characteristics such as suspended sediment, turbidity, colored dissolved organic matter (cDOM), and sediment-associated nutrients.",
      contacts: [
        {
          name: "James Duncker",
          title: "Basin Coordinator",
          contactInfo: {
            email: "jduncker@usgs.gov",
            phone: "217-493-7512",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://s3.console.aws.amazon.com/s3/object/ngwos-app-data?region=us-west-2&prefix=layer_data/irb_projects/FY22_NTG_HABS.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "x",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10379d34e7fc6a05060fb",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10379d34e7fc6a05060fb",
        },
      ],
    },
    "illinois-5": {
      name: "Water Chemistry",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "Water quality/water chemistry are important to establish the baseline conditions that impact many of the priority issues.  This information is important to both the HABs and nutrients monitoring as there is little known about the basic algal community and water chemistry conditions that trigger nuisance and harmful blooms.  This information will also help assess the risk that contaminants and water quality conditions pose to human health and the environment.",
      contacts: [
        {
          name: "James Duncker",
          title: "Basin Coordinator",
          contactInfo: {
            email: "jduncker@usgs.gov",
            phone: "217-493-7512",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://s3.console.aws.amazon.com/s3/object/ngwos-app-data?region=us-west-2&prefix=layer_data/irb_projects/FY22_NTG_Water+chemistry.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "x",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10379d34e7fc6a05060fb",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10379d34e7fc6a05060fb",
        },
      ],
    },
    "illinois-6": {
      name: "Urban Hydrology",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "The objective of this monitoring effort will be to evaluate new monitoring technology (spatially dense low-cost sensors and telemetry connectiveness) to address non-riverine urban flooding (a primary stakeholder issue in the ILRB).  ",
      contacts: [
        {
          name: "James Duncker",
          title: "Basin Coordinator",
          contactInfo: {
            email: "jduncker@usgs.gov",
            phone: "217-493-7512",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://s3.console.aws.amazon.com/s3/object/ngwos-app-data?region=us-west-2&prefix=layer_data/irb_projects/FY22_NTG_Urban+hydrology.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "x",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10379d34e7fc6a05060fb",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10379d34e7fc6a05060fb",
        },
      ],
    },
    "illinois-7": {
      name: "Sediment",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "The objectives of this monitoring effort will be a multi-scale approach consistent with the multi-level NGWOS pyramid to evaluate 1) next-generation sediment concentration monitoring instrumentation at an ILRB test bed site with existing instrumentation for profiling of acoustic sediment backscatter.  In early FY22, the ILRB NGWOS will deploy a Sequoia Instruments acoustic backscatter meter to the existing USGS supergage on the Illinois River at Florence, IL.  Evaluation and development of these instruments and methods will demonstrate improved data resolution, the cost efficiencies over traditional labor-intensive sediment sampling and lead to more widespread use amongst USGS offices nation-wide, and 2) collect core samples and suspended sediment samples in a sub-basin evaluate methods for sediment source-tracking and computing sediment budgets in the lower pools (LaGrange and Peoria) of the Illinois Waterway.",
      contacts: [
        {
          name: "James Duncker",
          title: "Basin Coordinator",
          contactInfo: {
            email: "jduncker@usgs.gov",
            phone: "217-493-7512",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://s3.console.aws.amazon.com/s3/object/ngwos-app-data?region=us-west-2&prefix=layer_data/irb_projects/FY22_NTG_Sediment.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "x",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10379d34e7fc6a05060fb",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10379d34e7fc6a05060fb",
        },
      ],
    },
    "illinois-8": {
      name: "Water Balance",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "The objective of this monitoring effort will be to collect the components of the basic water balance for the Illinois River Basin in support of IWAAs assessments and IWP basin-scale watershed modeling.  While some of this information is available from partner agencies and university researchers through data mining supported by IWAAs, in FY 21, the ILRB NGWOS purchased a Campbell Scientific meteorological station for deployment within the basin in 2022.  This equipment and instrumentation for computing meteorological data will be deployed as supplemental data necessary for soil moisture measurement and water balance computations.  ",
      contacts: [
        {
          name: "James Duncker",
          title: "Basin Coordinator",
          contactInfo: {
            email: "jduncker@usgs.gov",
            phone: "217-493-7512",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://s3.console.aws.amazon.com/s3/object/ngwos-app-data?region=us-west-2&prefix=layer_data/irb_projects/FY22_NTG_Water+balance.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "x",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10379d34e7fc6a05060fb",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10379d34e7fc6a05060fb",
        },
      ],
    },
    "illinois-9": {
      name: "New Technologies",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "The extensive monitoring planned for the ILRB NGWOS effort and the infrastructure of supergages and monitoring activities provides an ideal opportunity to test and evaluate new instrumentation.  Four proposals have been submitted for deployment in the ILRB, including image velocimetry, satellite-based flood inundation mapping, stage-from camera (machine-learning) and webcam image processing.",
      contacts: [
        {
          name: "James Duncker",
          title: "Basin Coordinator",
          contactInfo: {
            email: "jduncker@usgs.gov",
            phone: "217-493-7512",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://s3.console.aws.amazon.com/s3/object/ngwos-app-data?region=us-west-2&prefix=layer_data/irb_projects/FY22_NTG_New+technologies.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "x",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10379d34e7fc6a05060fb",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10379d34e7fc6a05060fb",
        },
      ],
    },
    "illinois-10": {
      name: "Water Temperature",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "Water temperature plays an important role in the timing and rate of many water quality processes that occur at all scales across the ILRB.  Data mining efforts in FY21 have shown an overall scarcity of water temperature data at the resolution needed for modeling at multiple scales.  In FY22, the NGWOS ILRB will procure 24 additional water temperature and air temperature sensors (HOBO DigiTemp) to be deployed as pairs (AT/WT) at strategic locations (TBD) across the basin.",
      contacts: [
        {
          name: "James Duncker",
          title: "Basin Coordinator",
          contactInfo: {
            email: "jduncker@usgs.gov",
            phone: "217-493-7512",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://s3.console.aws.amazon.com/s3/object/ngwos-app-data?region=us-west-2&prefix=layer_data/irb_projects/FY22_NTG_Water+temperature.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "x",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10379d34e7fc6a05060fb",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10379d34e7fc6a05060fb",
        },
      ],
    },
    "illinois-11": {
      name: "Remote Sensing",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "Remote sensing capabilities at several scales from non-contact multi-spectral cameras to satellite imagery have advanced rapidly in the last few years.  USGS researchers continue to test and develop new methods directly applicable to the Water Mission Area and Water Science Centers.  ",
      contacts: [
        {
          name: "James Duncker",
          title: "Basin Coordinator",
          contactInfo: {
            email: "jduncker@usgs.gov",
            phone: "217-493-7512",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "x",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10379d34e7fc6a05060fb",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10379d34e7fc6a05060fb",
        },
      ],
    },
    "illinois-12": {
      name: "AEM",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "Contracting for a more extensive AEM survey of the lower Illinois River Basin will commence in Fall 2021.  This survey will build upon the pilot effort in the Fox River watershed.  The AEM data is important to the understanding of streambed and floodplain sediment hydraulic properties and the spatial extent of groundwater-surface water interactions.",
      contacts: [
        {
          name: "James Duncker",
          title: "Basin Coordinator",
          contactInfo: {
            email: "jduncker@usgs.gov",
            phone: "217-493-7512",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/irb_projects/FY22_NTG_AEM.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "x",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10379d34e7fc6a05060fb",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10379d34e7fc6a05060fb",
        },
      ],
    },
    "illinois-13": {
      name: "Synoptics",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "NGWOS approach to monitoring is based on the pyramid shown previously, with emphasis to collect temporally and spatially dense data in selected sub-basins.  These surveys are labor intensive and provide a snapshot of water quality conditions to support basin scale modeling.",
      contacts: [
        {
          name: "James Duncker",
          title: "Basin Coordinator",
          contactInfo: {
            email: "jduncker@usgs.gov",
            phone: "217-493-7512",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/irb_projects/FY22_Synoptics.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "x",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10379d34e7fc6a05060fb",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b10379d34e7fc6a05060fb",
        },
      ],
    },
    "delaware-1": {
      name: "Meteorological and Soil Moisture Network Expansion",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "The goal of this project is to establish a network of meteorological stations that can be used to calculate potential evapotranspiration(PET) throughout the Delaware River Basin(DRB). This project will also test a new Snow Water Equivalent sensor (a SWE Plate) as an alternative to the more expensive Campbell CS725 Snow Water Equivalent (SWE) sensor.",
      contacts: [
        {
          name: "Mike McHale",
          title: "Project Lead",
          contactInfo: {
            email: "mmchale@usgs.gov",
            phone: "518-915-2547",
          },
        },
        {
          name: "Brandon Fleming",
          title: "Project Lead",
          contactInfo: {
            email: "bjflemin@usgs.gov",
            phone: "443-683-0250",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/drb_projects/FY22+DRB+NGWOS+All+Tasks.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "https://doimspp.sharepoint.com/sites/ngwosdrb/Shared Documents/General/Budget Information/../../../../../:b:/r/sites/ngwosdrb/Shared%20Documents/General/Request%20for%20Proposals%202021%20-%20Submission/Proposal%20Repository/NGWOS%20FY21%20McHale_Fleming%20PET%20Network%20Proposal.pdf?csf=1&web=1&e=zCd9wz",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b1035cd34e7fc6a05060f8",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b1035cd34e7fc6a05060f8",
        },
      ],
    },
    "delaware-2": {
      name: "Groundwater Saltwater Intrusion",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "This proposal is for the collection of chemistry and environmental tracer data from wells at risk from saltwater intrusion along the Delaware River due to future sea level rise and droughts. The sampling will include not only the production wells most atrisk but from surrounding wells that will help define chemical end-members that mix into production well waters. Results will help delineate the fraction of river water currently being drawn into the wells and the travel time distributions between the river and the wells. Results will be used to calibrate one-dimensional flow tube models based on advection-dispersion and/or stochastic assumptions. Results could be used to help calibrate existing or future regional groundwater flow/transport models.",
      contacts: [
        {
          name: "Emmanuel Charles",
          title: "Project Lead",
          contactInfo: {
            email: "echarles@usgs.gov",
            phone: "609-771-3928",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/drb_projects/FY22+DRB+NGWOS+All+Tasks.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "https://doimspp.sharepoint.com/sites/ngwosdrb/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2Fngwosdrb%2FShared%20Documents%2FGeneral%2FRequest%20for%20Proposals%202021%20%2D%20Submission%2FProposal%20Repository%2FNGWOS%20FY21%20NJ%20Saltwater%20intrusion%5Ffinal%2Epdf&parent=%2Fsites%2Fngwosdrb%2FShared%20Documents%2FGeneral%2FRequest%20for%20Proposals%202021%20%2D%20Submission%2FProposal%20Repository",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b1035cd34e7fc6a05060f8",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b1035cd34e7fc6a05060f8",
        },
      ],
    },
    "delaware-3": {
      name: "AEM Survey Data",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "Aerial EM survey of approximately 3000 km of transects along the Delaware Bay and shoreline region to identify the freshwater - Salt water interface in the shallow subsurface",
      contacts: [
        {
          name: "Burke Minsley",
          title: "Project Lead",
          contactInfo: {
            email: "bminsley@usgs.gov",
            phone: "303-236-5718",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/drb_projects/FY22+DRB+NGWOS+All+Tasks.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "https://doimspp.sharepoint.com/sites/ngwosdrb/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2Fngwosdrb%2FShared%20Documents%2FGeneral%2FRequest%20for%20Proposals%202021%20%2D%20Submission%2FProposal%20Repository%2FNGWOS%20FY21%20NJ%2DMDDEDC%20Aquifer%20Saltwater%20Monitoring%5FSubmit%2Epdf&parent=%2Fsites%2Fngwosdrb%2FShared%20Documents%2FGeneral%2FRequest%20for%20Proposals%202021%20%2D%20Submission%2FProposal%20Repository",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b1035cd34e7fc6a05060f8",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b1035cd34e7fc6a05060f8",
        },
      ],
    },
    "delaware-4": {
      name: "Geophysical AEM Support",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "Assembly and collection opf broehole geophysical data to support AEM survey",
      contacts: [
        {
          name: "Mark Nardi",
          title: "Project Lead",
          contactInfo: {
            email: "mrnardi@usgs.gov",
            phone: "302-213-5057",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/drb_projects/FY22+DRB+NGWOS+All+Tasks.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "https://doimspp.sharepoint.com/:x:/r/sites/ngwosdrb/Shared%20Documents/General/Proposals%20-%20FY22/FY22_AEM_Support_Activities_egc.xlsx?d=w2999efd4edb34625b77ea0ce60274d17&csf=1&web=1&e=9cDw9h",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b1035cd34e7fc6a05060f8",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b1035cd34e7fc6a05060f8",
        },
      ],
    },
    "delaware-5": {
      name: "Radiometer Monitoring",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "This project will test the use of hyperspectral radiometers to measure reflected sunlight from a river surface, with potential for future application making non-contact observations of water quality, including HABs, turbidity, dissolved organic matter, chlorophyll and other constituents. Funding is requested to support radiometer test deployments in DRB, IRB and UCRB NGWOS Basins as well as an equipment development and testing site in CA. Resulting hyperspectral data will be used to (i) assess non-contact sampling for above constituents and (ii) ground-truth and/or develop atmospheric correction algorithms for remote sensing data.",
      contacts: [
        {
          name: "Chuck Hansen",
          title: "Project Lead",
          contactInfo: {
            email: "jahansen@usgs.gov",
            phone: "916-278-3076",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/drb_projects/FY22+DRB+NGWOS+All+Tasks.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "https://doimspp.sharepoint.com/sites/ngwosdrb/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2Fngwosdrb%2FShared%20Documents%2FGeneral%2FRequest%20for%20Proposals%202021%20%2D%20Submission%2FProposal%20Repository%2FNGWOS%20FY21%20Proposal%20Combined%20Radiometry%5F%20Hansen%2Epdf&parent=%2Fsites%2Fngwosdrb%2FShared%20Documents%2FGeneral%2FRequest%20for%20Proposals%202021%20%2D%20Submission%2FProposal%20Repository",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b1035cd34e7fc6a05060f8",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b1035cd34e7fc6a05060f8",
        },
      ],
    },
    "delaware-6": {
      name: "FloaTEM",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "We propose further high-resolution mapping of the fresh/saline groundwater interface and significant hydrogeological units in the lower DRB using recently developed geophysical methodology (FloaTEM). ",
      contacts: [
        {
          name: "Neil Terry",
          title: "Project Lead",
          contactInfo: {
            email: "nterry@usgs.gov",
            phone: "860-487-7402",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/drb_projects/FY22+DRB+NGWOS+All+Tasks.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "https://doimspp.sharepoint.com/sites/ngwosdrb/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2Fngwosdrb%2FShared%20Documents%2FGeneral%2FRequest%20for%20Proposals%202021%20%2D%20Submission%2FProposal%20Repository%2FNGWOS%20FY21%20Proposal%20FloaTEM%5Fsubmit%2Epdf&parent=%2Fsites%2Fngwosdrb%2FShared%20Documents%2FGeneral%2FRequest%20for%20Proposals%202021%20%2D%20Submission%2FProposal%20Repository",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b1035cd34e7fc6a05060f8",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b1035cd34e7fc6a05060f8",
        },
      ],
    },
    "delaware-7": {
      name: "Flow Permanence",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "We propose a combination of continuous monitoring of stream water level height and water temperature as well as synoptic point discharge measurements at many locations to field truth flow permanence of the headwaters of the Neversink watershed.",
      contacts: [
        {
          name: "Donald Bonville",
          title: "Project Lead",
          contactInfo: {
            email: "dbonville@usgs.gov",
            phone: "518-697-9811",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/drb_projects/FY22+DRB+NGWOS+All+Tasks.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "https://doimspp.sharepoint.com/sites/ngwosdrb/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2Fngwosdrb%2FShared%20Documents%2FGeneral%2FRequest%20for%20Proposals%202021%20%2D%20Submission%2FProposal%20Repository%2FNGWOS%20FY21%20Proposal%20Flow%20Permanence%20DBBonville%2Epdf&parent=%2Fsites%2Fngwosdrb%2FShared%20Documents%2FGeneral%2FRequest%20for%20Proposals%202021%20%2D%20Submission%2FProposal%20Repository",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b1035cd34e7fc6a05060f8",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b1035cd34e7fc6a05060f8",
        },
      ],
    },
    "delaware-8": {
      name: "NADP Precipitation Isotopes",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "This proposal involves analysis of water stable isotopes in samples from the National Atmospheric Deposition Program (NADP) to augmentbaseline data in the Delaware (DRB) and Upper Colorado (UCOL) river basins. Questions that can be addressed with an improved precipitation data set include improved understanding of seasonal and spatial variation in isotope tracer signal for recharge source assessmentand effects of climateand land-covershifts on hydrology.",
      contacts: [
        {
          name: "Martha Scholl",
          title: "Project Lead",
          contactInfo: {
            email: "mascholl@usgs.gov",
            phone: "703-648-5890",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/drb_projects/FY22+DRB+NGWOS+All+Tasks.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "https://doimspp.sharepoint.com/sites/ngwosdrb/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2Fngwosdrb%2FShared%20Documents%2FGeneral%2FRequest%20for%20Proposals%202021%20%2D%20Submission%2FProposal%20Repository%2FNGWOS%20FY21%20Proposal%20NADP%5FPrecipitation%5FIsotopes%2Epdf&parent=%2Fsites%2Fngwosdrb%2FShared%20Documents%2FGeneral%2FRequest%20for%20Proposals%202021%20%2D%20Submission%2FProposal%20Repository",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b1035cd34e7fc6a05060f8",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b1035cd34e7fc6a05060f8",
        },
      ],
    },
    "delaware-9": {
      name: "Neversink Temp Extension",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "To better constrain GW/SW exchange process and streamflow generation end members, we propose to leverage these existing monitoring sites and collect seasonal stable water isotopes, dissolved radon, and depth to bedrock data. This new data collection would also include an interim download of the paired air/water temperature loggers in late spring rather than waiting until September 2021 to retrieve any temperature data. Analysis scripts could be developed to increase efficiency and help ensure consistency for additional temperature data in the DRB. ",
      contacts: [
        {
          name: "Martin Briggs",
          title: "Project Lead",
          contactInfo: {
            email: "mbriggs@usgs.gov",
            phone: "860-487-7402",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/drb_projects/FY22+DRB+NGWOS+All+Tasks.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "https://doimspp.sharepoint.com/:x:/r/sites/ngwosdrb/Shared%20Documents/General/Proposals%20-%20FY22/NGWOS_FY22-Project-Plan_Neversink_Temp.xlsx?d=w4636cd64c642449b9f7080ee36e57c07&csf=1&web=1&e=It1xvR",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b1035cd34e7fc6a05060f8",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b1035cd34e7fc6a05060f8",
        },
      ],
    },
    "delaware-10": {
      name: "Rancocas Temperature Synoptic",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "Inclusion of the NJ Rancocas focus subbasin under this larger umbrella of NGWOS paired air/water temperature monitoring would allow characterization of the unique Pine Barrens landscape, representing an important headwater endmember with unique hydrogeology.",
      contacts: [
        {
          name: "Heidi Hoppe",
          title: "Project Lead",
          contactInfo: {
            email: "hhoppe@usgs.gov",
            phone: "609-771-3980",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/drb_projects/FY22+DRB+NGWOS+All+Tasks.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "https://doimspp.sharepoint.com/sites/ngwosdrb/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2Fngwosdrb%2FShared%20Documents%2FGeneral%2FRequest%20for%20Proposals%202021%20%2D%20Submission%2FProposal%20Repository%2FNGWOS%20FY21%20Proposal%20NJ%5Fsubbasin%5Fair%5Fwater%5Ftemperature%5Fsubmit%2Epdf&parent=%2Fsites%2Fngwosdrb%2FShared%20Documents%2FGeneral%2FRequest%20for%20Proposals%202021%20%2D%20Submission%2FProposal%20Repository",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b1035cd34e7fc6a05060f8",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b1035cd34e7fc6a05060f8",
        },
      ],
    },
    "delaware-11": {
      name: "Surface Water Saltwater Intrusion",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "Expand the current water-quality network in Delaware and New Jersey to help with monitoring the effects of sea level rise and storm tides pushing saltwater up small stream basins.",
      contacts: [
        {
          name: "Anthony Tallman",
          title: "Project Lead",
          contactInfo: {
            email: "atallman@usgs.gov",
            phone: "302-213-5061",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/drb_projects/FY22+DRB+NGWOS+All+Tasks.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "https://doimspp.sharepoint.com/sites/ngwosdrb/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2Fngwosdrb%2FShared%20Documents%2FGeneral%2FRequest%20for%20Proposals%202021%20%2D%20Submission%2FProposal%20Repository%2FNGWOS%20FY21%20Saltwater%20Intrusion%20and%20Sea%20Level%20Rise%20Monitoring%20in%20SW%2Epdf&parent=%2Fsites%2Fngwosdrb%2FShared%20Documents%2FGeneral%2FRequest%20for%20Proposals%202021%20%2D%20Submission%2FProposal%20Repository",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b1035cd34e7fc6a05060f8",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b1035cd34e7fc6a05060f8",
        },
      ],
    },
    "delaware-12": {
      name: "SC-Cl Surrogate Modeling",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "The purpose of this activity is to expand current chloride (Cl) monitoring and support data mining and synthesis to facilitate the development of regional specific conductance-chloride (SC-Cl) surrogate models to estimate high-frequency Cl concentrations across the DRB monitoring network, which is comprised on more than 100 currently-operating SC monitoring stations. ",
      contacts: [
        {
          name: "Rosemary Fanelli",
          title: "Project Lead",
          contactInfo: {
            email: "rfanelli@usgs.gov",
            phone: "919-571-4036",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/drb_projects/FY22+DRB+NGWOS+All+Tasks.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "https://doimspp.sharepoint.com/sites/ngwosdrb/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2Fngwosdrb%2FShared%20Documents%2FGeneral%2FRequest%20for%20Proposals%202021%20%2D%20Submission%2FProposal%20Repository%2FNGWOS%20FY21%5FDeveloping%5FSC%5FCl%5Fregional%5Fsurrogate%5Fmodels%5Facross%5FDRB%2Epdf&parent=%2Fsites%2Fngwosdrb%2FShared%20Documents%2FGeneral%2FRequest%20for%20Proposals%202021%20%2D%20Submission%2FProposal%20Repository",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b1035cd34e7fc6a05060f8",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b1035cd34e7fc6a05060f8",
        },
      ],
    },
    "delaware-13": {
      name: "Little Lehigh Temperature Synoptic",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "A network of paired stream water and local air temperature monitoring is proposed for deployment over one year in the Little Lehigh Creek Intensive Sub-basin. The Little Lehigh offers an end-member example of karst terrain within the Valley and Ridge physiographic province where it would be broadly useful to define high resolution spatial patterns in groundwater influence, stream temperature sensitivity, and stream disconnection at low flow. ",
      contacts: [
        {
          name: "Brandon Fleming",
          title: "Project Lead",
          contactInfo: {
            email: "bjfleming@usgs.gov",
            phone: "717-730-6970",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/drb_projects/FY22+DRB+NGWOS+All+Tasks.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "https://doimspp.sharepoint.com/sites/ngwosdrb/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2Fngwosdrb%2FShared%20Documents%2FGeneral%2FRequest%20for%20Proposals%202021%20%2D%20Submission%2FProposal%20Repository%2FNGWOS%5FFY21%5FProposal%20Little%5FLehigh%5FAir%5FWater%5FTemp%2Epdf&parent=%2Fsites%2Fngwosdrb%2FShared%20Documents%2FGeneral%2FRequest%20for%20Proposals%202021%20%2D%20Submission%2FProposal%20Repository",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b1035cd34e7fc6a05060f8",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b1035cd34e7fc6a05060f8",
        },
      ],
    },
    "delaware-14": {
      name: "Self-Supplied Domestic Water Use Monitoring",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "Network design for self-supplied domestic water use monitoring, and sub-basin and basin-wide expansion of self-supplied domestic water use monitoring network in the Delaware River Basin. ",
      contacts: [
        {
          name: "Jaymes Swain",
          title: "Project Lead",
          contactInfo: {
            email: "jswain@usgs.gov",
            phone: "302-213-5058",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/drb_projects/FY22+DRB+NGWOS+All+Tasks.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "https://doimspp.sharepoint.com/:w:/r/sites/ngwosdrb/_layouts/15/Doc.aspx?sourcedoc=%7B4C32C11D-93E9-4D67-A7F7-CD3135708965%7D&file=32_NGWOS%20FY20%20WSC%20Priorities%20-%20DRB%20Domestic%20Water%20Use%2003052020.docx&action=default&mobileredirect=true&cid=243fce3b-a2e4-4fd7-827a-80712d10fd22",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b1035cd34e7fc6a05060f8",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b1035cd34e7fc6a05060f8",
        },
      ],
    },
    "delaware-15": {
      name: "WCC Sediment and Other Sites",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "High spatial and temporal resolution sediment monitoring coupled with chemical and physical sediment-source characterization and topographic differencing methods in the White Clay Creek Basin to determine the sources and timing of sediment delivery in support of future sediment modelling efforts. ",
      contacts: [
        {
          name: "Joe Duris",
          title: "Project Lead",
          contactInfo: {
            email: "jwduris@usgs.gov",
            phone: "717-730-6930",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/drb_projects/FY22+DRB+NGWOS+All+Tasks.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "https://teams.microsoft.com/l/file/5B93C6D9-EDBE-4095-AC48-FAC8F84A7267?tenantId=0693b5ba-4b18-4d7b-9341-f32f400a5494&fileType=pdf&objectUrl=https%3A%2F%2Fdoimspp.sharepoint.com%2Fsites%2Fngwosdrb%2FShared%20Documents%2FGeneral%2FRequest%20for%20Proposals%202021%20-%20Submission%2FProposal%20Repository%2FNGWOS%20FY21_DRB%20Geomorphology%2BSediment%20Sourcing%20as%20input%20for%20future%20DRB%20Sediment%20Flux%20Monitoring_Duris_Gellis_Noe.pdf&baseUrl=https%3A%2F%2Fdoimspp.sharepoint.com%2Fsites%2Fngwosdrb&serviceName=teams&threadId=19:6fb8c4c156af4522a60654209759ab14@thread.skype&groupId=1cf758dd-9824-4aee-9efe-ff18c2949083",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b1035cd34e7fc6a05060f8",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b1035cd34e7fc6a05060f8",
        },
      ],
    },
    "delaware-16": {
      name: "Mapping Hydrogeomorphic Landforms",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "Shallow groundwater storage estimation from depth-to-bedrock estimates",
      contacts: [
        {
          name: "Daniel Doctor",
          title: "Project Lead",
          contactInfo: {
            email: "dhdoctor@usgs.gov",
            phone: "703-648-6027",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/drb_projects/FY22+DRB+NGWOS+All+Tasks.xlsx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "https://doimspp.sharepoint.com/:w:/r/sites/ngwosdrb/Shared%20Documents/General/Proposals%20-%20FY22/Doctor_NGWOS%20FY22%20Proposal_Neversink%20mapping.docx?d=w55a546ef67b642a6bfc588e6a6b41d49&csf=1&web=1&e=CeBokb",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b1035cd34e7fc6a05060f8",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b1035cd34e7fc6a05060f8",
        },
      ],
    },
    "national-1": {
      name: "Remote Sensing of Water Quality",
      avatar: "avatarsrc.png",
      status: "Active",
      description: "RSWQ Project Description",
      contacts: [
        {
          name: "Tyler King",
          title: "Project Lead",
          contactInfo: {
            email: "tvking@usgs.gov",
            phone: "208-387-1352",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "Add Budget",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "Add Proposal",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "Add SB",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "www.example.com",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "Add Link",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "Add Link",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "Add Link",
        },
      ],
    },
    "national-2": {
      name: "NGWOS Portal",
      avatar: "avatarsrc.png",
      status: "Active",
      description:
        "This project will support NGWOS project goals by supporting principal investigators, basin coordinators, and stakeholders by aggregating internal and external data sources in each of the basins, and delivering either the data themselves, metadata, and/or links to data repositories. As the quantity and types of data collected in the DRB, IRB and UCRB NGWOS Basins continue to increase, the need for a central repository or directory of these data has become crucial to efficiently communicating data availability and retrieval methods to all stakeholders. This project will build on the existing resources of previous and ongoing projects to deliver NGWOS and relevant ancillary information through a portal hosted in the CHS Tableau Server environment.",
      contacts: [
        {
          name: "Chuck Hansen",
          title: "Project Lead",
          contactInfo: {
            email: "jahansen@usgs.gov",
            phone: "916-278-3076",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/national_ngwos_projects/NGWOS+FY22+Portal+Proposal+Hansen_V2.docx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/national_ngwos_projects/NGWOS+FY22+Portal+Proposal+Hansen_V2.docx",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b0c13bd34eb622f69b9697",
        },
      ],
      products: [
        {
          title: "A Cool Project Web App",
          description: "Click this link to check out our cool web app!",
          src: "http://ngwos-app-dev.s3-website.us-west-2.amazonaws.com/",
        },
        {
          title: "A Paper from the Project",
          description: "Here is our official paper",
          src: "www.example.com",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "http://ngwos-app-dev.s3-website.us-west-2.amazonaws.com/",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "http://ngwos-app-dev.s3-website.us-west-2.amazonaws.com/",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b0c13bd34eb622f69b9697",
        },
      ],
    },
    "national-3": {
      name: "Surface Velocity",
      avatar: "avatarsrc.png",
      status: "Active",
      description: "Surface Velocity Vizualization Project Description",
      contacts: [
        {
          name: "Geoffrey P Debenedetto",
          title: "Project Lead",
          contactInfo: {
            email: "gdebened@usgs.gov",
            phone: "928-556-7353",
          },
        },
      ],
      quickLinks: [
        {
          title: "Budget",
          description: "Budget details",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/national_ngwos_projects/NGWOS+FY22+Portal+Proposal+Hansen_V2.docx",
        },
        {
          title: "Proposal",
          description: "Link to project proposal",
          src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/national_ngwos_projects/NGWOS+FY22+Portal+Proposal+Hansen_V2.docx",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b0c13bd34eb622f69b9697",
        },
      ],
      products: [
        {
          title: "Surface Velocity Vizualization",
          description: "Web application for viewing surface velocity data",
          src: "http://surface-velocity-app-dev.s3-website-us-west-2.amazonaws.com/",
        },
      ],
      otherResources: [
        {
          title: "Project Website",
          description: "This is another website for our project",
          src: "http://ngwos-app-dev.s3-website.us-west-2.amazonaws.com/",
        },
        {
          title: "A relevant article",
          description: "An article that inspired the project",
          src: "www.example.com",
        },
      ],
      images: [
        {
          title: "Project Website",
          description: "Additional project details",
          src: "http://ngwos-app-dev.s3-website.us-west-2.amazonaws.com/",
        },
        {
          title: "ScienceBase",
          description: "Access project data",
          src: "https://www.sciencebase.gov/catalog/item/61b0c13bd34eb622f69b9697",
        },
      ],
    },
    // "basin-information-ngwos": {
    //   name: "NGWOS National Information",
    //   avatar: "avatarsrc.png",
    //   status: "Active",
    //   description:
    //     "Substantial advances in water science, together with emerging breakthroughs in technical and computational capabilities, have led the USGS to develop a Next Generation Water Observing System (NGWOS). The USGS NGWOS will provide real-time data on water quantity and quality in more affordable and rapid ways than previously possible, and in more locations.",
    //   contacts: [
    //     {
    //       name: "Chad Wagner",
    //       title: "Program Coordinator",
    //       contactInfo: {
    //         email: "cwagner@usgs.gov",
    //         phone: "919-571-4021",
    //       },
    //     },
    //     {
    //       name: "Brian Pellerin",
    //       title: "Program Manager (acting)",
    //       contactInfo: {
    //         email: "bpeller@usgs.gov",
    //         phone: "703-648-6865",
    //       },
    //     },
    //   ],
    //   quickLinks: [
    //     {
    //       title: "Next Generation Water Observing System (NGWOS)",
    //       description: "Program Home",
    //       src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-ngwos",
    //     },
    //     {
    //       title: "ScienceBase Home Page",
    //       description: "NGWOS Data and Projects",
    //       src: "https://www.sciencebase.gov/catalog/item/61b0c13bd34eb622f69b9697",
    //     },
    //   ],
    //   products: [],
    //   otherResources: [],
    //   images: [],
    // },
    // "basin-information-ucrb": {
    //   name: "Upper Colorado River Basin Information",
    //   avatar: "avatarsrc.png",
    //  status: "Active",
    //   description:
    //     "The Next Generation Water Observing System provides high-fidelity, real-time data on water quantity, quality, and use to support modern water prediction and decision-support systems that are necessary for informing water operations on a daily basis and decision-making during water emergencies. The headwaters of the Colorado and Gunnison River Basin provide an opportunity to implement the NGWOS in a snowmelt-dominated system in the mountain west.",
    //   contacts: [
    //     {
    //       name: "Suzanne Paschke",
    //       title: "Basin Coordinator",
    //       contactInfo: {
    //         email: "spaschke@usgs.gov",
    //         phone: "303-236-6904",
    //       },
    //     },
    //   ],
    //   quickLinks: [
    //     {
    //       title: "Upper Colorado River Basin",
    //       description: "Basin Home",
    //       src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-upper-colorado-river",
    //     },
    //     {
    //       title: "ScienceBase Home Page",
    //       description: "NGWOS Data and Projects",
    //       src: "https://www.sciencebase.gov/catalog/item/61b10337d34e7fc6a05060f5",
    //     },
    //   ],
    //   products: [],
    //   otherResources: [],
    //   images: [],
    // },
    // "basin-information-irb": {
    //   name: "Illinois River Basin Information",
    //   avatar: "avatarsrc.png",
    //  status: "Active",
    //   description:
    //     "The Next Generation Water Observing System provides high-fidelity, real-time data on water quantity, quality, and use to support modern water prediction and decision-support systems that are necessary for informing water operations on a daily basis and decision-making during water emergencies. The Illinois River Basin provides an opportunity to implement the NGWOS in a system challenged by an overabundance of nutrients—primarily nitrogen and phosphorus—and associated harmful algal blooms.",
    //   contacts: [
    //     {
    //       name: "James Duncker",
    //       title: "Basin Coordinator",
    //       contactInfo: {
    //         email: "jduncker@usgs.gov",
    //         phone: "217-493-7512",
    //       },
    //     },
    //   ],
    //   quickLinks: [
    //     {
    //       title: "Illinois River Basin",
    //       description: "Basin Home",
    //       src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-illinois-river-basin",
    //     },
    //     {
    //       title: "Project Outline",
    //       description: "Project Plan",
    //       src: "https://ngwos-app-data.s3.us-west-2.amazonaws.com/layer_data/irb_projects/NGWOS_FY22_TOPICS_proposal_20210809_DEC.docx",
    //     },
    //     {
    //       title: "ScienceBase Home Page",
    //       description: "NGWOS Data and Projects",
    //       src: "https://www.sciencebase.gov/catalog/item/61b10379d34e7fc6a05060fb",
    //     },
    //   ],
    //   products: [],
    //   otherResources: [],
    //   images: [],
    // },
    // "basin-information-drb": {
    //   name: "Delaware River Basin Information",
    //   avatar: "avatarsrc.png",
    //  status: "Active",
    //   description:
    //     "The USGS Next Generation Water Observing System (NGWOS) provides high-fidelity, real-time data on water quantity and quality necessary to support modern water prediction and decision support systems for water emergencies and daily water operations. The Delaware River Basin was the first NGWOS basin, providing an opportunity to implement the program in a nationally important, complex interstate river system.",
    //   contacts: [
    //     {
    //       name: "Doug Burns",
    //       title: "Basin Coordinator",
    //       contactInfo: {
    //         email: "daburns@usgs.gov",
    //         phone: "518-285-5662",
    //       },
    //     },
    //   ],
    //   quickLinks: [
    //     {
    //       title: "Delaware River Basin",
    //       description: "Basin Home",
    //       src: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-delaware-river-basin",
    //     },
    //     {
    //       title: "ScienceBase Home Page",
    //       description: "NGWOS Data and Projects",
    //       src: "https://www.sciencebase.gov/catalog/item/61b1035cd34e7fc6a05060f8",
    //     },
    //   ],
    //   products: [],
    //   otherResources: [
    //     {
    //       title: "Basin Visualization",
    //       description: "Basin Public Viz",
    //       src: "https://labs.waterdata.usgs.gov/visualizations/delaware-basin-story/index.html#/",
    //     },
    //   ],
    //   images: [],
    // },
  },
  allIds: [
    "colorado-1",
    "colorado-2",
    "colorado-3",
    "colorado-4",
    "colorado-5",
    "colorado-6",
    "colorado-7",
    "colorado-8",
    "colorado-9",
    "colorado-10",
    "colorado-11",
    "colorado-12",
    "colorado-13",
    "illinois-1",
    "illinois-2",
    "illinois-3",
    "illinois-4",
    "illinois-5",
    "illinois-6",
    "illinois-7",
    "illinois-8",
    "illinois-9",
    "illinois-10",
    "illinois-11",
    "illinois-12",
    "illinois-13",
    "delaware-1",
    "delaware-2",
    "delaware-3",
    "delaware-4",
    "delaware-5",
    "delaware-6",
    "delaware-7",
    "delaware-8",
    "delaware-9",
    "delaware-10",
    "delaware-11",
    "delaware-12",
    "delaware-13",
    "delaware-14",
    "delaware-15",
    "national-1",
    "national-2",
    "national-3",
    // "basin-information-ngwos",
    // "basin-information-ucrb",
    // "basin-information-irb",
    // "basin-information-drb",
  ],
};
